import Image from 'next/image'
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'
import TutorProfileAvailability from './Availability'
import {
  faCertificate,
  faHome,
  faInfoCircle,
  faLaptop,
  faRoute,
  faShield,
  faShieldAlt
} from '@fortawesome/free-solid-svg-icons'
import Tooltip from 'react-bootstrap/Tooltip'

export default function TutorProfileSummaryPanel({tutorProfile, showName}) {
  const referenceAverageAttributes = [
    {
      attribute: 'averageReliabilityRating',
      label: 'Reliability'
    },
    {
      attribute: 'averageCommitmentRating',
      label: 'Commitment'
    },
    {
      attribute: 'averagePunctualityRating',
      label: 'Punctuality'
    },
    {
      attribute: 'averageHonestyRating',
      label: 'Honesty'
    },
  ]

  return <>
    <div className="mb-4 text-center">
      <Image
        src={tutorProfile.profilePicture.url}
        alt={`${tutorProfile.firstNameAndLastInitial} photo`}
        width={200}
        height={200}
        className="rounded mb-2"
        style={{
          maxWidth: "100%",
          height: "auto"
        }} />

      {showName &&
        <h3 className="mb-3">{tutorProfile.fullName}</h3>
      }

      <em className="d-block">{tutorProfile.tagLine}</em>
    </div>

    <h5>Availability</h5>
    <TutorProfileAvailability tutorProfile={tutorProfile} />

    {tutorProfile.lessonsAtHome &&
      <div className="mb-2">
        <FontAwesomeIcon icon={faHome} fixedWidth className="text-success me-1" />
        Gives Lessons at Home
      </div>
    }

    {tutorProfile.lessonsTravel &&
      <div className="mb-2">
        <FontAwesomeIcon icon={faRoute} fixedWidth className="text-success me-1" />
        Will Travel to You
      </div>
    }

    {tutorProfile.lessonsOnline &&
      <div className="mb-2">
        <FontAwesomeIcon icon={faLaptop} fixedWidth className="text-success me-1" />
        Gives Lessons Online
      </div>
    }

    {tutorProfile.hasDbsCertificate &&
      <>
        <hr />
        <div className="mb-2">
          <FontAwesomeIcon icon={faCertificate} fixedWidth className="text-success me-1" />
          Has DBS Certificate
        </div>
      </>
    }

    {tutorProfile.hasCompletedReferences &&
      <>
        <hr />
        <h5>
          References
          <small>
            <FontAwesomeIcon icon={faInfoCircle} fixedWidth size="sm" />
            <Tooltip title="Average ratings across all references for this tutor" />
          </small>
        </h5>

        {referenceAverageAttributes.map(average => (
          <div className="mb-2" key={average}>
            <FontAwesomeIcon icon={faShieldAlt} fixedWidth className="text-success me-1" />
            <strong>{average.label}:</strong>
            {tutorProfile[average.attribute]}
          </div>
        ))
        }
      </>
    }
  </>
}
